import searchReducer from './searchReducer';
import geoSuggestionReducer from './geoSuggestionReducer';
import seoDataReducer from './seoDataReducer';
import trackingReducer from './trackingReducer';
import branchenbuchReducer from './branchenbuchReducer';
import agentTeaserReducer from './agentTeaserReducer';
import dynamicFaqReducer from './dynamicFaqReducer';
import regionSeoContentReducer from './regionSeoContentReducer';
import initialState from '../store/initialState';
var rootReducer = function rootReducer(state, action) {
  return {
    search: searchReducer(state.search, action),
    config: state.config,
    gacOverAllInfo: geoSuggestionReducer(state.gacOverAllInfo, action),
    tracking: trackingReducer(state.tracking, action),
    seoData: seoDataReducer(state.seoData, action),
    branchenbuchSearch: branchenbuchReducer(state.branchenbuchSearch, action),
    teaserData: agentTeaserReducer(state.teaserData, action),
    dynamicFaq: dynamicFaqReducer(state.dynamicFaq, action),
    regionSeoContent: regionSeoContentReducer(state.regionSeoContent, action)
  };
};
export var rootInitialState = initialState;
export default rootReducer;